import { Link } from 'react-router-dom';
import { SIGNUP_URL, WEB_URL } from '../config';

export function BillingPage() {
  return (
    <section className="px-6 pt-28 pb-20 lg:px-10 lg:pt-36">
      <div className="mx-auto max-w-[720px]">
        <div className="mb-5 inline-flex items-center gap-2 rounded-full border border-brand/15 bg-brand-light px-3 py-1.5 text-[0.72rem] font-bold tracking-widest text-brand uppercase">
          Billing
        </div>
        <h1 className="font-display mb-4 text-[2.75rem] leading-[1.06] font-extrabold text-ink lg:text-[3.25rem]">
          Checkout is not on this website.
        </h1>
        <p className="mb-8 text-[1.0625rem] leading-[1.7] text-ink-2">
          cevop.com shows catalog prices. Accounts and paid plans live in the Business app. We do not collect card
          numbers here.
        </p>
        <div className="mk-stagger mb-8 space-y-3">
          {[
            ['See amounts', 'Pricing lists NGN monthly prices from the Billing catalog.'],
            ['Create an account', 'Start free opens Business app signup. Free does not require a card.'],
            ['Paid plans', 'When billing is live for your organisation, you manage it in-app — not a marketing checkout.'],
            ['Enterprise', 'Contact sales. There is no self-serve Enterprise price.'],
          ].map(([title, body]) => (
            <div key={title} className="mk-lift rounded-2xl border border-line bg-panel p-5 shadow-sm">
              <div className="font-display mb-1 text-[0.95rem] font-bold text-ink">{title}</div>
              <p className="text-[0.85rem] leading-[1.65] text-ink-3">{body}</p>
            </div>
          ))}
        </div>
        <div className="flex flex-col gap-3 sm:flex-row">
          <Link
            to="/pricing"
            className="inline-flex items-center justify-center rounded-xl bg-brand px-7 py-3.5 font-semibold text-brand-on hover:bg-brand-hover"
          >
            View pricing
          </Link>
          <a
            href={SIGNUP_URL}
            className="inline-flex items-center justify-center rounded-xl border border-line-strong px-7 py-3.5 font-semibold text-ink hover:bg-surface-2"
          >
            Start free
          </a>
          <a
            href={WEB_URL}
            className="inline-flex items-center justify-center rounded-xl border border-line-strong px-7 py-3.5 font-semibold text-ink hover:bg-surface-2"
          >
            Open Business app
          </a>
        </div>
      </div>
    </section>
  );
}
